import { render, staticRenderFns } from "./MozTitle.vue?vue&type=template&id=44086f96&scoped=true&"
import script from "./MozTitle.vue?vue&type=script&lang=js&"
export * from "./MozTitle.vue?vue&type=script&lang=js&"
import style0 from "./MozTitle.vue?vue&type=style&index=0&id=44086f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44086f96",
  null
  
)

export default component.exports